import { ErrorLink } from '@apollo/client/link/error';
import {
  clearAccessTokenCookie,
  clearLegacyAuthSessionStorage,
} from 'auth/auth-cookie';
import {
  clearActiveProfileUuid,
  clearStoredProfiles,
} from 'profile/active-profile.storage';
import { isInvalidAccessTokenError } from './auth-error';

let hasClearedInvalidSession = false;

function clearInvalidSession() {
  if (hasClearedInvalidSession) {
    return;
  }

  hasClearedInvalidSession = true;
  clearAccessTokenCookie();
  clearLegacyAuthSessionStorage();
  clearStoredProfiles();
  clearActiveProfileUuid();

  if (typeof window !== 'undefined') {
    window.location.reload();
  }
}

export const apolloAuthErrorLink = new ErrorLink(({ error }) => {
  if (isInvalidAccessTokenError(error)) {
    clearInvalidSession();
  }
});
